import { MapUtils } from '../../../utility/map-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../../dto/data-model.js';

export class TicketPoolShard extends DataModel {
  static readonly TYPE_ID: string = 'b74068ae9324a9da20826cf665ebf30';

  private constructor(
    public readonly uniqueId: string,
    public readonly templateId: string,
    public readonly limit: number,
    public count: number,
  ) {
    super();
  }

  get $typeId(): string {
    return TicketPoolShard.TYPE_ID;
  }

  static create(args: {
    uniqueId: string,
    templateId: string,
    limit: number,
    count: number,
  }): TicketPoolShard {
    return new TicketPoolShard(
        args.uniqueId,
        args.templateId,
        args.limit,
        args.count,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): TicketPoolShard {
    return this.create({
      uniqueId: MapUtils.getString(map, 'uniqueId'),
      templateId: MapUtils.getString(map, 'templateId'),
      limit: MapUtils.getNumber(map, 'limit'),
      count: MapUtils.getNumber(map, 'count'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      uniqueId: this.uniqueId,
      templateId: this.templateId,
      limit: this.limit,
      count: this.count,
    };
  }

  clone(): this {
    return TicketPoolShard.create({
      uniqueId: this.uniqueId,
      templateId: this.templateId,
      limit: this.limit,
      count: this.count,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
      other.templateId === this.templateId &&
      other.limit === this.limit &&
      other.count === this.count;
  }
}

export class TicketPoolShardBuilder extends DataModelBuilder<TicketPoolShard> {
  build(context: SerializationContext, map: SerializedData): TicketPoolShard {
    return TicketPoolShard.fromMap(context, map);
  }
}
